export default {
  id: 15,
  pride: 5120,
  slug: "beyond-books-disillusionment",
  series: "beyond-books",
  category: "novel",
  status: "concept",
  experienceable: true,
  titleKey: {
    zh: "不止于纸上的故事：幻灭篇",
    en: "Beyond Books: Disillusionment"
  },
  image: require('@/assets/images/bbd.webp'),
  descriptionKey: {
    zh: "本来想做严肃游戏，讲高中学习方法和心界起源的，但是我还不如直接跟你讲。",
    en: "Originally intended as a serious game about high school study methods and the origin of 'Heart World', but I'd rather just tell you directly."
  },
  date: { year: 2024, month: 7 },
  genres: ["严肃游戏", "教育"],
  themes: ["学习方法", "心理"],
  engine: "Node.js",
  platform: ["Web"],
  developerNotesKey: {
    zh: "本来想做严肃游戏，讲高中学习方法和心界起源的，但是我还不如直接跟你讲。",
    en: "Originally intended as a serious game about high school study methods and the origin of 'Heart World', but I'd rather just tell you directly."
  },
  tags: ["不止于纸上"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "blog", url: "https://tobenot.top/Beyond-Books-Disillusionment/", textKey: { zh: "阅读", en: "Read" } }
  ]
};
